"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseVoucherInterestSettings = exports.DebtorImposedBy = exports.OrderedCaseVoucherCategories = exports.CaseVoucherCategories = exports.DebtorVoucherTypes = exports.DisbursementVoucherTypes = exports.FeeVoucherTypes = exports.RegularFeeVoucherTypes = exports.CollectionComissionVoucherTypes = void 0;
const __1 = require("..");
const _1 = require(".");
exports.CollectionComissionVoucherTypes = [
    _1.VoucherTypeIds.COLLECTIONCOMMISSION,
    _1.VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT,
    _1.VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE,
];
exports.RegularFeeVoucherTypes = [
    _1.VoucherTypeIds.ENDCASEFEE,
    _1.VoucherTypeIds.RKIREGISTRATIONFEE,
    _1.VoucherTypeIds.BPKFEE,
    _1.VoucherTypeIds.FOLKEREGISTEROPSLAG,
    _1.VoucherTypeIds.ANMELDELSEAFKRAV,
    _1.VoucherTypeIds.FOGEDFEE,
    _1.VoucherTypeIds.JURIDISKBISTAND,
    _1.VoucherTypeIds.STARTCASEFEE,
    _1.VoucherTypeIds.BERAMMELSESAFGIFT,
    _1.VoucherTypeIds.AFLYSNINGAFUDLAEG,
    _1.VoucherTypeIds.LOCKSMITHFEE,
    _1.VoucherTypeIds.DRIVINGFEE,
    _1.VoucherTypeIds.OTHERFEE,
];
exports.FeeVoucherTypes = [
    ...exports.CollectionComissionVoucherTypes,
    ...exports.RegularFeeVoucherTypes,
];
exports.DisbursementVoucherTypes = [
    _1.VoucherTypeIds.BPKDISBURSEMENT,
    _1.VoucherTypeIds.FOGEDDISBURSEMENT,
    _1.VoucherTypeIds.POLICEDISBURSEMENT,
    _1.VoucherTypeIds.STAEVNINGSGEBYR,
    _1.VoucherTypeIds.BERAMMELSESAFGIFT,
];
exports.DebtorVoucherTypes = [
    _1.VoucherTypeIds.DEPOSIT,
    _1.VoucherTypeIds.WITHDRAWAL,
    _1.VoucherTypeIds.INVOICE,
    _1.VoucherTypeIds.CREDITNOTE,
    _1.VoucherTypeIds.GAELDSBREV,
    _1.VoucherTypeIds.SETTLEMENT,
    _1.VoucherTypeIds.FINALINVOICE,
    _1.VoucherTypeIds.ONACCOUNTINVOICE,
    _1.VoucherTypeIds.DOM,
    _1.VoucherTypeIds.CONTROLFEE,
    _1.VoucherTypeIds.COLLECTIONCOST,
    _1.VoucherTypeIds.COLLECTIONFEE,
    _1.VoucherTypeIds.REMINDERFEE,
    _1.VoucherTypeIds.COMPENSATIONCOST,
    _1.VoucherTypeIds.Folkeregisteropslag,
    _1.VoucherTypeIds.UDTRAEKSGEBYR,
    _1.VoucherTypeIds.ADMINISTRATIONCOST,
    _1.VoucherTypeIds.BAILIFFSFEE,
    _1.VoucherTypeIds.BAILIFSSALARY,
    _1.VoucherTypeIds.WRITFEE,
    _1.VoucherTypeIds.WRITSALARY,
    _1.VoucherTypeIds.POLICEPRESENTATIONFEE,
    _1.VoucherTypeIds.MeetingFee,
    _1.VoucherTypeIds.FOGEDREKVISITIONSFEE,
    _1.VoucherTypeIds.FIXEDINTEREST,
    _1.VoucherTypeIds.GLPROCESSINTEREST,
    _1.VoucherTypeIds.PROCESSINTEREST,
    _1.VoucherTypeIds.YEARLYINTEREST,
];
exports.CaseVoucherCategories = [
    _1.VoucherCategory.TRANSACTION,
    _1.VoucherCategory.PRINCIPAL,
    _1.VoucherCategory.COST,
    _1.VoucherCategory.COURTCOST,
    _1.VoucherCategory.INTEREST,
];
exports.OrderedCaseVoucherCategories = [
    _1.VoucherCategory.PRINCIPAL,
    _1.VoucherCategory.COST,
    _1.VoucherCategory.COURTCOST,
    _1.VoucherCategory.INTEREST,
    _1.VoucherCategory.TRANSACTION,
];
exports.DebtorImposedBy = [
    __1.CaseVoucherTags.IMPOSEDBYCREDITOR,
    __1.CaseVoucherTags.IMPOSEDBYCOLLECTOR,
];
exports.CaseVoucherInterestSettings = [
    _1.VoucherTypeSetting.CompoundInterest,
    _1.VoucherTypeSetting.InterestFromTable,
    _1.VoucherTypeSetting.YearlyInterest,
];
//# sourceMappingURL=setup.js.map